/**
 * Clear Cart — subtle link on the ajax cart drawer and the cart page that opens
 * a confirmation modal before emptying the cart.
 *
 * Why a single delegated listener + one shared modal: the cart drawer renders on
 * every page (including the cart page), so this asset's button can appear more
 * than once. Guarding on a window flag, delegating from the document, and reusing
 * one lazily-built <dialog> keeps exactly one handler and one modal alive.
 *
 * Why <dialog>.showModal(): it renders in the browser top layer (above the
 * drawer's z-index), traps focus, and closes on Esc for free.
 *
 * All copy is passed in via data-* attributes on the trigger so it stays in the
 * theme locale files rather than hard-coded here.
 */
(function () {
  if (window.__fndClearCartInit) return;
  window.__fndClearCartInit = true;

  var dialog, titleEl, bodyEl, confirmBtn, cancelBtn;

  function buildModal() {
    dialog = document.createElement('dialog');
    dialog.className = 'fnd-modal';
    dialog.setAttribute('role', 'alertdialog');
    dialog.setAttribute('aria-labelledby', 'fnd-clear-title');
    dialog.setAttribute('aria-describedby', 'fnd-clear-body');
    dialog.innerHTML =
      '<div class="fnd-modal__inner">' +
        '<h2 class="fnd-modal__title" id="fnd-clear-title" data-modal-title></h2>' +
        '<p class="fnd-modal__body" id="fnd-clear-body" data-modal-body></p>' +
        '<div class="fnd-modal__actions">' +
          '<button type="button" class="fnd-modal__btn fnd-modal__btn--cancel" data-modal-cancel></button>' +
          '<button type="button" class="fnd-modal__btn fnd-modal__btn--confirm" data-modal-confirm></button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dialog);

    titleEl = dialog.querySelector('[data-modal-title]');
    bodyEl = dialog.querySelector('[data-modal-body]');
    confirmBtn = dialog.querySelector('[data-modal-confirm]');
    cancelBtn = dialog.querySelector('[data-modal-cancel]');

    cancelBtn.addEventListener('click', closeModal);
    confirmBtn.addEventListener('click', clearCart);
    // Click on the backdrop (the dialog element itself) dismisses.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeModal();
    });
  }

  function openModal(trigger) {
    if (!dialog) buildModal();

    titleEl.textContent = trigger.getAttribute('data-clear-title') || 'Clear your cart?';
    bodyEl.textContent = trigger.getAttribute('data-clear-body') || '';
    confirmBtn.textContent = trigger.getAttribute('data-clear-confirm') || 'Clear cart';
    cancelBtn.textContent = trigger.getAttribute('data-clear-cancel') || 'Cancel';
    confirmBtn.removeAttribute('aria-busy');

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', ''); // very old browsers: non-modal fallback
    }
    cancelBtn.focus(); // default focus on the safe action
  }

  function closeModal() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function clearCart() {
    if (confirmBtn.getAttribute('aria-busy') === 'true') return;
    confirmBtn.setAttribute('aria-busy', 'true');

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'include'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/clear.js failed: ' + response.status);
        // Reload so both the drawer and the cart page reflect the empty cart.
        window.location.reload();
      })
      .catch(function (error) {
        console.error('[FND] clear cart failed', error);
        confirmBtn.removeAttribute('aria-busy');
        closeModal();
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-clear-cart]');
    if (!trigger) return;
    event.preventDefault(); // the trigger lives inside the cart <form>; never submit
    openModal(trigger);
  });
})();
